import { cn } from '@/utils';
import { webmotorsLoaderStyles } from './webmotors-loader.styles';
import type { TWebmotorsLoaderConfig } from './webmotors-loader.types';

const WebmotorsLoader = ({
	size = 76,
	overlay = false,
	className,
	...props
}: TWebmotorsLoaderConfig) => {
	const svg = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 250 250"
			width={size}
			height={size}
			className={webmotorsLoaderStyles.svg}
			role="img"
			aria-label="Carregando"
		>
			<path fill="#b6061e" d="M50 50h150v150H50z" />
			<path
				className="wm-loader-path"
				d="M68 83v84.3-32.2c0-5.3 4.4-9.7 9.7-9.7h37.2c5.3 0 10-4.4 10-10v-38 95.1-37.4c0-5.3 4.4-9.7 9.7-9.7h37.2c5.6 0 10-4.7 10-10h0V83v84.1"
				fill="none"
				stroke="#fff"
				strokeWidth="23"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit="10"
				strokeDasharray="600"
				strokeDashoffset="600"
			/>
			<path
				d="M124.8 5.5C58.6 5.5 5.2 58.9 5.2 124.8s53.4 119.6 119.6 119.6c65.9 0 119.6-53.4 119.6-119.6-.3-65.9-53.7-119.3-119.6-119.3zM191.3 166c0 5.6-4.7 10-10.3 10-5.3-.3-9.4-5-9.4-10.3v-25.6c0-2.8-2.5-5.3-5.3-5.3h-26.5c-2.8 0-5.3 2.5-5.3 5.3V172c0 5.6-4.7 10-10.3 10-5.3-.3-9.4-5-9.4-10.3v-31.2c0-2.8-2.5-5.3-5.3-5.3H83c-2.8 0-5.3 2.5-5.3 5.3v26.2c0 5.6-4.7 10-10.3 10-5.3-.3-9.4-5-9.4-10.3V83.6c0-5.6 4.7-10 10.3-10 5.3.3 9.4 5 9.4 10.3v25.6c0 2.8 2.5 5.3 5.3 5.3h26.5c2.8 0 5.3-2.5 5.3-5.3V78c0-5.6 4.7-10 10.3-10 5.3.3 9.4 5 9.4 10.3v31.2c0 2.8 2.5 5.3 5.3 5.3h26.5c2.8 0 5.3-2.5 5.3-5.3V83.9c0-5.3 4.1-10 9.4-10.3 5.6-.3 10.3 4.4 10.3 10V166z"
				fill="#ec0928"
			/>
			<circle className="wm-loader-circle" r="11" cx="67.8" cy="83.1" fill="#fff" stroke="#ddd" />
		</svg>
	);

	if (overlay) {
		return (
			<div className={cn(webmotorsLoaderStyles.overlay, className)} {...props}>
				{svg}
			</div>
		);
	}

	return (
		<div className={cn(webmotorsLoaderStyles.root, className)} {...props}>
			{svg}
		</div>
	);
};

WebmotorsLoader.displayName = 'WebmotorsLoader';

export { WebmotorsLoader };
